module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length > 0) ? _c('div', [_c('m-header', {
    attrs: {
      "backFn": "true",
      "title": "一元夺酒"
    },
    on: {
      "back": _vm.back
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.data[0].data.image_default_id,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "7rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.data[0].data.status != 'WORKING') ? _c('div', {
    staticClass: "content-top"
  }, [_c('div', {
    staticClass: "title relative text-l ellipsis-1 "
  }, [_c('b', [_vm._v(_vm._s(_vm.data[0].data.sub_title))]), _vm._v(" "), _c('span', {
    staticClass: "end vux-1px"
  }, [_vm._v("已揭晓")])]), _vm._v(" "), _c('div', {
    staticClass: "title relative text-l ellipsis-1 flex top-detail"
  }, [_c('span', {
    staticClass: "ellipsis-1 flex-1"
  }, [_vm._v(_vm._s(_vm.data[0].data.title))]), _vm._v(" "), _c('p', {
    staticClass: "fr",
    on: {
      "click": function($event) {
        _vm.toDetail(_vm.data[0].data.item_id)
      }
    }
  }, [_vm._v("查看详情"), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "gain-info flex"
  }, [_c('div', {
    staticClass: "head-pic"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm._f("headimgurl")(_vm.data[1].data.user_info),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text text-l"
  }, [_c('p', [_vm._v(_vm._s(_vm._f("name")(_vm.data[1].data.user_info)))]), _vm._v(" "), _c('p', [_vm._v("幸运号码 " + _vm._s(_vm.data[1].data.final_number))]), _vm._v(" "), _c('p', [_vm._v("参与" + _vm._s(_vm.data[1].data.buy_number) + "份")]), _vm._v(" "), _c('p', [_vm._v("揭晓时间 " + _vm._s(_vm._f("timer")(_vm.data[1].data.final_time)))])]), _vm._v(" "), _c('router-link', {
    staticClass: "tag ",
    attrs: {
      "tag": "span",
      "to": {
        name: 'formula',
        params: {
          rob_id: _vm.data[0].data.rob_id
        }
      }
    }
  }, [_vm._v("\n                    计算公式\n                ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.data[0].data.status == 'WORKING') ? _c('div', {
    staticClass: "content-top"
  }, [_c('div', {
    staticClass: "title relative text-l ellipsis-1 "
  }, [_c('b', [_vm._v(_vm._s(_vm.data[0].data.sub_title))]), _vm._v(" "), _c('span', {
    staticClass: "end vux-1px jinx"
  }, [_vm._v("进行中")])]), _vm._v(" "), _c('div', {
    staticClass: "title relative text-l ellipsis-1 flex top-detail"
  }, [_c('span', {
    staticClass: "ellipsis-1 flex-1"
  }, [_vm._v(_vm._s(_vm.data[0].data.title))]), _vm._v(" "), _c('p', {
    staticClass: "fr",
    on: {
      "click": function($event) {
        _vm.toDetail(_vm.data[0].data.item_id)
      }
    }
  }, [_vm._v("查看详情"), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-box"
  }, [_c('div', {
    staticClass: "des flex"
  }, [_c('span', [_vm._v("开奖进度" + _vm._s(_vm.progress(_vm.data[0].data)))]), _c('span', [_vm._v("总需" + _vm._s(_vm.data[0].data.buy_number) + "份")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('i', {
    style: ({
      width: _vm.progress(_vm.data[0].data)
    })
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "participate-list"
  }, [_c('h1', {
    staticClass: "text-l title"
  }, [_vm._v("土豪榜")]), _vm._v(" "), _c('div', {
    staticClass: "flex ranking"
  }, [_vm._l((_vm.data[2].data), function(item, index) {
    return _c('div', {
      staticClass: "flex-1"
    }, [_c('span', {
      staticClass: "no"
    }, [_vm._v("No." + _vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "head-pic"
    }, [(item.headimgurl) ? _c('img', {
      attrs: {
        "src": item.headimgurl,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (!item.headimgurl) ? _c('img', {
      attrs: {
        "src": require("./head.png"),
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), (item.name) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.name) ? _c('span', {
      staticClass: "name"
    }, [_vm._v("虚位以待")]) : _vm._e(), _vm._v(" "), (item.buy_num) ? _c('p', {
      staticClass: "num"
    }, [_vm._v("参与" + _vm._s(item.buy_num) + "份")]) : _vm._e(), _vm._v(" "), (!item.buy_num) ? _c('p', {
      staticClass: "num"
    }, [_vm._v("等待参与")]) : _vm._e()])
  }), _vm._v(" "), _vm._l((3), function(item, index) {
    return (!_vm.data[2].data) ? _c('div', {
      staticClass: "flex-1"
    }, [_c('span', {
      staticClass: "no"
    }, [_vm._v("No." + _vm._s(index + 1))]), _vm._v(" "), _vm._m(0, true), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v("虚位以待")]), _vm._v(" "), _c('p', {
      staticClass: "num"
    }, [_vm._v("等待参与")])]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.data[3].data) ? _c('div', {
    staticClass: "all-list"
  }, [_c('div', {
    staticClass: "list-box"
  }, [_c('div', {
    staticClass: "title text-l border-b"
  }, [_vm._v("本期参与记录")]), _vm._v(" "), _vm._l((_vm.data[3].data), function(item) {
    return _c('div', {
      staticClass: "list-info flex vux-1px-b"
    }, [_c('div', {
      staticClass: "head-pic"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("headimgurl")(item.user_info),
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name flex text-l flex-1"
    }, [_c('span', {}, [_vm._v(_vm._s(_vm._f("name")(item.user_info)))]), _vm._v(" "), _c('div', {
      staticClass: "flex date"
    }, [_c('span', [_vm._v("参与" + _vm._s(item.buy_num) + "份")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timer")(item.created_time)))])])])])
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.data[0].data.status == 'WORKING') ? _c('footer', {
    on: {
      "click": function($event) {
        _vm.show = true
      }
    }
  }, [_c('div', [_vm._v("参与夺酒")])]) : _vm._e(), _vm._v(" "), (_vm.data[0].data.status != 'WORKING') ? _c('div', {
    staticClass: "footer flex"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'detail',
        params: {
          id: _vm.data[0].data.item_id
        }
      },
      "tag": "div"
    }
  }, [_vm._v("直接购买")]), _vm._v(" "), _c('div', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v("查看其它活动")])], 1) : _vm._e(), _vm._v(" "), (_vm.data[0].data.status != 'ENDING' && _vm.data[4].error_code == 0) ? _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }],
    staticClass: "pay-box"
  }, [_c('popup', {
    attrs: {
      "height": "50%",
      "is-transparent": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "title vux-1px-b flex"
  }, [_c('span', [_vm._v("请选择参与份数")]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-cuowu",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "num flex vux-1px-b"
  }, [_c('span', {
    staticClass: "flex-1",
    on: {
      "click": function($event) {
        _vm.rem(_vm.num)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jian"
  })]), _vm._v(" "), _c('span', {
    staticClass: "flex-1"
  }, [_vm._v(_vm._s(_vm.num))]), _vm._v(" "), _c('span', {
    staticClass: "flex-1",
    on: {
      "click": function($event) {
        _vm.num++
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-jia"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "title  flex"
  }, [_c('span', [_vm._v("请选择收货地址")])]), _vm._v(" "), _c('div', {
    staticClass: "flex address",
    on: {
      "click": _vm.toAddress
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-weizhi"
  }), _vm._v("收件人：" + _vm._s(_vm.data[4].addrDef.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.data[4].addrDef.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "address address-text text-l relative",
    on: {
      "click": _vm.toAddress
    }
  }, [_vm._v("\n                收货地址：" + _vm._s(_vm._f("addressList")(_vm.data[4].addrDef.area, _vm.data[4].addrDef.addr)) + "\n                "), _c('i', {
    staticClass: "iconfont icon-youjiantou-copy"
  })]), _vm._v(" "), _c('div', {
    staticClass: "foot",
    on: {
      "click": _vm.createNumbers
    }
  }, [_vm._v("立即夺酒")])])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-pic"
  }, [_c('img', {
    attrs: {
      "src": require("./head.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-563035a2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TakeWineDetail/TakeWineDetail.vue
// module id = 570
// module chunks = 0